<template>
  <div
    class="respond-card shadow-level-1"
    :data-id="fields && fields.id && fields.id.value ? fields.id.value : ''"
  >
    <PublicatorAuthDialog
      v-if="is_visible.publicator_auth_dialog"
      :is_visible="is_visible.publicator_auth_dialog"
      :needToImport="false"
      @reset-callback="checkAuth"
    />
    <div class="respond-card__top" v-if="metaData && !respondPageLoading">
      <div class="respond-card__top-message">
        <div
          v-if="message && message.length"
          class="respond-card__top-message__text"
        >
          {{ message }}
        </div>
        <div
          v-if="buttons"
          v-loading="requestSent"
          class="respond-card__top-message__buttons"
        >
          <FormButtons
            v-for="item in buttons"
            :key="item.lbl.name"
            :buttons_menu="[[item]]"
            view-type="detail"
          ></FormButtons>
        </div>
      </div>
      <div class="respond-card__top-close">
        <Button
          buttonSize="small"
          buttonColor="transparent"
          buttonText=""
          iconColor="#788694"
          hasRightIcon
          iconName="Cross"
          style="width: 24px"
          @click="closeCard"
        />
      </div>
    </div>
    <div class="respond-card__page">
      <Respond
        v-loading="respondPageLoading"
        v-if="metaData && fields && !respondPageLoading"
        :buttons_menu="metaData.buttons_menu"
        :panels="panels"
        :fields="fields"
        :subpanels="
          metaData.subpanels && metaData.subpanels.panelColumn
            ? metaData.subpanels.panelColumn
            : []
        "
      />
    </div>
  </div>
</template>

<script>
import { store } from '@/store';
import { eventBus } from '@/bus';
import { mixin, errorMsg } from '@/utils/mixins';
import { MODULE, INTENT_AREA } from '@/utils/constants';
import Respond from './Respond';
import Button from 'Elements/Button/Button';
import PublicatorAuthDialog from 'Elements/Dialog/PublicatorAuthDialog';
import { getController } from '@/controllers/request.js';
import FormButtons from 'Elements/Form/FormButtons';

export default {
  mixins: [mixin, errorMsg],
  props: {
    respondId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentVacancyId: null,
      MODULE,
      module: MODULE.CANDIDATES_MODULE,
      loading: true,
      resumeText: '',
      newCandidateId: null,
      work_site: '',
      requestSent: false
    };
  },

  created() {
    this.loading = true;
    eventBus.$on(INTENT_AREA.SEND_REQUEST, async intent => {
      this.newCandidateId = '';
      this.requestSent = true;
      const response = await getController({
        url: intent.request.url,
        params: {
          ...intent.request.request_params
        }
      });
      this.handleRequest(
        response,
        intent.request.url.includes('rejectResponse') ? false : true
      );
      this.requestSent = false;
      eventBus.$on(INTENT_AREA.CARD, this.goToCandidate);
    });

    store.dispatch('respond/getMetadata', this.respondId);
  },
  beforeDestroy() {
    store.commit('respond/setParam', {
      name: 'currentVacancyRespond',
      val: null
    });
    localStorage.setItem('currentVacancyRespondId', null);
    eventBus.$off(INTENT_AREA.SEND_REQUEST);
    eventBus.$off(INTENT_AREA.CARD, this.goToCandidate);
  },
  computed: {
    fields() {
      return store.state.respond.metadata?.bean || {};
    },
    respondPageLoading() {
      return store.state.respond.loading || false;
    },
    metaData() {
      return store.state.respond.metadata?.metadata || {};
    },
    message() {
      return (
        store.state.respond.metadata?.metadata?.panels[0]?.rows[0][0]?.value ||
        ''
      );
    },
    buttons() {
      return store.state.respond.metadata?.metadata?.panels[1].rows[0] || [];
    },
    panels() {
      return store.state.respond.metadata?.metadata?.panels?.slice(1) || [];
    },
    is_visible() {
      return store.state.common.visible_dialog;
    }
  },
  methods: {
    async checkAuth() {
      this.closeDialog('publicator_auth_dialog', null);
      await store.dispatch('publicator/checkAuth', this.work_site);
      if (
        store.state.publicator.authForm?.length &&
        store.state.publicator.authForm.some(
          formItem =>
            formItem.name == this.work_site &&
            Object.keys(formItem.authData).length
        )
      ) {
        this.showNotification({
          offset: 100,
          showClose: true,
          message:
            'Авторизация прошла успешно. Выберите решение по отклику еще раз',
          duration: 15000,
          type: 'success'
        });
      } else {
        this.showNotification({
          offset: 100,
          showClose: true,
          message: 'Авторизация не была завершена',
          duration: 15000,
          type: 'error'
        });
      }

      this.work_site = '';
      store.commit('publicator/setImportData', {});
    },
    closeCard() {
      store.commit('respond/setParam', {
        name: 'currentVacancyRespond',
        val: null
      });
      localStorage.setItem('currentVacancyRespondId', null);
      if (
        this.$router.history?.current?.meta?.module == MODULE.CANDIDATES_MODULE
      ) {
        this.$router.push('/candidates');
      }
    },
    async handleRequest(response, redirect = false) {
      if (response?.data?.candidate_id) {
        this.newCandidateId = response.data?.candidate_id;

        if (
          response?.data?.error?.error_text &&
          response?.data?.status == 'error'
        ) {
          this.showNotification({
            showClose: true,
            message: response.data.error.error_text || 'Ошибка принятия отклика',
            duration: 60000,
            type: 'error'
          });
        }
      } else if (
        response?.data?.error &&
        response?.data?.error == 'token error' &&
        response?.data?.work_site
      ) {
        this.work_site = response.data.work_site;
        store.commit('publicator/setAuthForm', {
          name: response.data.work_site
        });
        store.commit('publicator/setImportData', {
          work_site: response.data.work_site
        });

        store.commit('common/setVisibleDialog', {
          name: 'publicator_auth_dialog',
          val: true
        });
      }

      this.$emit('reloadReapods');

      localStorage.setItem('currentVacancyRespondId', this.respondId);
      store.dispatch('respond/getMetadata', this.respondId);
      if (redirect && this.newCandidateId) {
        this.goToCandidate();
      }
    },
    async goToCandidate() {
      const route = this.$router.resolve({
        path: `/candidates/${this.newCandidateId}`
      });
      window.open(route.href);
    }
  },
  components: {
    Respond,
    Button,
    FormButtons,
    PublicatorAuthDialog
  }
};
</script>

<style lang="scss" scoped>
.respond-card {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 170px);
  background: $white;
  border-radius: 4px;

  &__page {
    overflow-y: auto;
  }

  &__top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    border-radius: 4px 4px 0 0;
    max-width: inherit;
    z-index: 2;
    background: white;
    border-bottom: 1px solid $grey8;

    &-message {
      flex: 1;
      padding: 16px 24px;

      &__text {
        background: $grey8;
        border-radius: 4px;
        font-size: 14px;
        line-height: 24px;
        color: $grey80;
        padding: 16px;
        text-align: left;
        margin-bottom: 16px;
        overflow-y: auto;
        max-height: 165px;
      }

      &__buttons {
        display: flex;
        gap: 16px;
        width: fit-content;

        & > .buttons-panel {
          width: unset;
        }
      }
    }

    &-close {
      border-left: 1px solid $grey8;
      padding: 24px;
    }

    &-buttons {
      padding: 16px 8px 16px 24px;
    }
  }
}

@media (max-width: 1199px) {
  .respond-card__page {
    width: 100%;
    min-width: 766px;
    max-width: 100%;
    display: grid;
  }
}

@media (min-width: 1200px) {
  .respond-card__page {
    min-width: 766px;
    max-width: 766px;
  }
}

@media (min-width: 1512px) {
  .respond-card__page {
    min-width: 766px;
    max-width: 872px;
  }
}
</style>
